"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchRouteVars = exports.endpointUrlWithQsParams = exports.endpointUrl = exports.qsParamsToStringOrEmpty = exports.endpointPath = exports.EndpointPathExtraDataTreatment = void 0;
const { compile, match } = require("path-to-regexp");
const queryString = require('query-string');
const plus_plus_plus_1 = require("../exceptions/plus-plus-plus");
const assert_args_present_1 = require("../exceptions/assert-args-present");
// const _pathBuilderByRouteDefinition = {} as Record<string, ((data?: any) => string)>;
var EndpointPathExtraDataTreatment;
(function (EndpointPathExtraDataTreatment) {
    EndpointPathExtraDataTreatment["ToQsParams"] = "QsParams";
    EndpointPathExtraDataTreatment["Ignore"] = "Ignore";
    EndpointPathExtraDataTreatment["ThrowError"] = "ThrowError";
})(EndpointPathExtraDataTreatment = exports.EndpointPathExtraDataTreatment || (exports.EndpointPathExtraDataTreatment = {}));
/**
 * Returns pathname applying embedded vars, with options to include remaining data items in queryString.
 */
function endpointPath(routeDefinition, data, opts = {}) {
    assert_args_present_1.assertRequiredArgsDefined({ routeDefinition, data });
    const extraDataTreatment = opts.extraDataTreatment || EndpointPathExtraDataTreatment.ToQsParams;
    const builder = compile(routeDefinition);
    // let builder = _pathBuilderByRouteDefinition[routeDefinition];
    // if (!builder) {
    //   builder = compile(routeDefinition);
    //   if (cacheCompiledRoute) {
    //     _pathBuilderByRouteDefinition[routeDefinition] = builder;
    //   }
    // }
    const { embeddedParams, qsParams } = _separateParams(routeDefinition, data || {});
    const pathname = builder(embeddedParams);
    if (extraDataTreatment === EndpointPathExtraDataTreatment.Ignore) {
        return pathname;
    }
    else {
        const qsParamCount = Object.keys(qsParams).length;
        if (!qsParamCount) {
            return pathname;
        }
        else if (extraDataTreatment === EndpointPathExtraDataTreatment.ToQsParams) {
            // todo: check if path already has search params
            return `${pathname}?${queryString.stringify(qsParams)}`;
        }
        else if (extraDataTreatment === EndpointPathExtraDataTreatment.ThrowError) {
            throw new plus_plus_plus_1.PlusPlusPlus('UnexpectedPathData', {
                reason: `Unexpected data provided while building path when "extraDataTreatment" option set to "${EndpointPathExtraDataTreatment.ThrowError}"`,
                unexpectedFields: Object.keys(qsParams),
                routeDefinition,
                opts,
            });
        }
        else {
            throw new plus_plus_plus_1.PlusPlusPlus('InvalidArgs', {
                reason: 'Unknown value for "extraDataTreatment" field provided',
                extraDataTreatment,
                routeDefinition,
            });
        }
    }
}
exports.endpointPath = endpointPath;
/**
 * Returns a record of key/value pairs in url syntax. Eg qsParamsToString({ aa: 11, bb: 22 }) returns aa=11&bb=22
 * note: Does not add the "?"
 *
 * @param params
 */
function qsParamsToStringOrEmpty(params) {
    const hasInfo = params && typeof params === 'object' && Object.keys(params).length > 0;
    return hasInfo ? queryString.stringify(params) : '';
}
exports.qsParamsToStringOrEmpty = qsParamsToStringOrEmpty;
/**
 * Builds a URL from a route definition that might contain vars embedded in the path (eg: "/photos/:photoId") resolving the
 *  embedded vars with passed-in data
 *
 *
 * @returns {string}
 * @param args
 */
function endpointUrl(args) {
    let baseUrl = args.baseUrl;
    if (!baseUrl || typeof baseUrl !== 'string') {
        throw new Error('Expecting baseUrl. The protocol, hostname and optional port. Eg, https://example.com');
    }
    const { embeddedData, routeDefinition, pathOpts } = args;
    if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1);
    }
    return `${baseUrl}${endpointPath(routeDefinition, embeddedData, pathOpts)}`;
}
exports.endpointUrl = endpointUrl;
function endpointUrlWithQsParams(args) {
    return endpointUrl(Object.assign(Object.assign({}, args), { pathOpts: {
            extraDataTreatment: EndpointPathExtraDataTreatment.ToQsParams,
        } }));
}
exports.endpointUrlWithQsParams = endpointUrlWithQsParams;
function matchRouteVars({ routeDef, pathWithData }) {
    const matchFn = match(routeDef, { decode: decodeURIComponent });
    const { params } = matchFn(pathWithData);
    return params;
}
exports.matchRouteVars = matchRouteVars;
function _separateParams(routeDefinition, params) {
    const embeddedParams = {};
    const qsParams = {};
    Object.keys(params).forEach(varName => {
        if (routeDefinition.indexOf(varName) >= 0) {
            embeddedParams[varName] = params[varName];
        }
        else {
            qsParams[varName] = params[varName];
        }
    });
    return { embeddedParams, qsParams };
}
//# sourceMappingURL=url-endpoint-util.js.map